/* Dirty Fruit motion layer — reveal on scroll, count-up, meter fill, accordion */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('df-anim'); // progressive enhancement: only hide when JS runs

  // Reveal on scroll
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('df-in');
        // count-up
        if (e.target.hasAttribute('data-count')) countUp(e.target);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  function bind() {
    document.querySelectorAll('.df-reveal:not(.df-bound)').forEach(function (el) {
      el.classList.add('df-bound');
      if (reduce) { el.classList.add('df-in'); if (el.hasAttribute('data-count')) finalCount(el); }
      else io.observe(el);
    });
    // Accordion
    document.querySelectorAll('.df-acc__q:not(.df-bound)').forEach(function (q) {
      q.classList.add('df-bound');
      q.addEventListener('click', function () {
        var item = q.closest('.df-acc__item');
        var open = item.classList.contains('open');
        item.classList.toggle('open', !open);
        q.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  function finalCount(el){ el.textContent = el.getAttribute('data-count') + (el.getAttribute('data-suffix') || ''); }
  function countUp(el) {
    if (reduce) return finalCount(el);
    var target = parseFloat(el.getAttribute('data-count'));
    var suffix = el.getAttribute('data-suffix') || '';
    var dur = 900, start = null;
    function step(ts){
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var v = (target * (0.5 - Math.cos(p * Math.PI) / 2));
      el.textContent = (target % 1 ? v.toFixed(1) : Math.round(v)) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind); // theme editor
  bind();
})();
